angular.module('TurneroApp').component('coPuestosAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'puestosService',
        'utilsService',
        'TurneroAppConstant',
        function (puestosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.puestoAlta = {};

            ctrl.errores = {
                N_Puesto: false
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.puestoAlta = {};

                    ctrl.errores = {
                        N_Puesto: false
                    };

                    puestosService.getInfo({ 'id_Puesto': ' ', 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (data) {
                        ctrl.puestoAlta = data;
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
            }

            ctrl.guardarPuestoNuevo = function () {
                ctrl.puestoAlta.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id
                ctrl.errores.N_Puesto = !(ctrl.puestoAlta.N_Puesto);

                if (ctrl.errores.N_Puesto) {
                    return;
                }

                ctrl.puestoAlta.$save(function (data) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Alta Puesto", "El puesto se registró correctamente", "success");
                }, function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./puestosAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/puestos/puestosAltaComponent.js